import { Field, reduxForm, SubmissionError } from "redux-form";
import { Button, Input } from "expano-components";

import { Dashboard } from "components";

import useUpdate from "hooks/useUpdate";

const InputField = (props) => <Input {...props} />;

const PackagesData = ({
  product_id,
  refetch,
  handleSubmit,
  pristine,
  invalid,
}) => {
  const { is_updating, update } = useUpdate({
    path: `/products/${product_id}`,
    onSuccess: refetch,
    onError: (err) => {
      throw new SubmissionError(err);
    },
  });

  const onSubmit = (values) => update(values);

  return (
    <Dashboard
      header={{ title: "Opakowanie", icon: "package_sizes" }}
      footer={
        <>
          <Button
            type="save"
            text={is_updating ? "Proszę czekać..." : "Zapisz"}
            disabled={pristine || invalid || is_updating}
            onClick={handleSubmit(onSubmit)}
          />
        </>
      }
    >
      <form
        className="dashboard__form"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        <div className="row m-b-10">
          <div className="box-6">
            <Field
              name="weight"
              label="Waga"
              postfix="kg"
              component={InputField}
            />
          </div>
          <div className="box-6">
            <Field
              name="package_height"
              label="Wysokość"
              postfix="cm"
              component={InputField}
            />
          </div>
        </div>
        <div className="row">
          <div className="box-6">
            <Field
              name="package_width"
              label="Szerokość"
              postfix="cm"
              component={InputField}
            />
          </div>
          <div className="box-6">
            <Field
              name="package_depth"
              label="Głębokość"
              postfix="cm"
              component={InputField}
            />
          </div>
        </div>
      </form>
    </Dashboard>
  );
};

export default reduxForm({
  form: "update-product-package",
  enableReinitialize: true,
})(PackagesData);
